export const PLAYER_VAULT_ENDPOINTS = {
  CLAIM_REQUESTS: {
    LIST: "/api/v1/player-vault/admin/claim-requests",
    APPROVE: "/api/v1/player-vault/admin/claim-requests/{id}/approve",
    REJECT: "/api/v1/player-vault/admin/claim-requests/{id}/reject",
  },
} as const;
